module.exports = __webpack_public_path__ + "img/racecourse-mauritius-turf.45dd5502.svg";